var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenBlock = function SvgOpenBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4526 4.41003C27.117 4.41003 30.8983 8.19129 30.8983 12.8557V13.0548L27.9485 16.0021L30.8983 18.9466V19.1486C30.8983 23.813 27.117 27.5943 22.4526 27.5943H1.08997L7.91802 22.6262H19.3062C22.9645 22.6262 25.9302 19.6605 25.9302 16.0021C25.9302 12.3438 22.9645 9.37809 19.3062 9.37809H7.91802L1.08997 4.41003H22.4526ZM9.50802 13.1867C7.95322 13.1867 6.69279 14.4472 6.69279 16.002C6.69279 17.5568 7.95319 18.8172 9.50802 18.8172H19.316C20.8708 18.8172 22.1312 17.5568 22.1312 16.002C22.1312 14.4472 20.8708 13.1867 19.316 13.1867H9.50802Z",
    fill: "#4A3DE6"
  })));
};

export { SvgOpenBlock as ReactComponent };
export default __webpack_public_path__ + "f4103fe13eb8932457890328df460e51.svg";